import React, {useEffect, useState} from "react";
import {
    Button,
    Col,
    Divider,
    Form,
    Input,
    InputNumber,
    Row,
    Select,
    Switch,
    TimePicker,
    Tooltip,
    TreeSelect,
} from "antd";
import {MinusCircleOutlined, MinusOutlined, PlusOutlined, QuestionCircleOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import dayjs from "dayjs";
import {getJobPositions} from "../../../../../../api/setting/personnel/job-position/api";
import {getJobTitles} from "../../../../../../api/setting/personnel/job-title/api";
import DG_TreeSelect_Department from "../../../../../../custom/data-entry/tree-select/department/Department";
import {useParams} from "react-router-dom";
import {useForm} from "antd/es/form/Form";
import ShiftGps from "./ShiftGps";
import InputDecimal from "../../../../../../custom/data-entry/input-number/InputDecimal";

const GeneralSeting = (props) => {
    const {t} = useTranslation();
    const id = props?.id;
    const {Option} = Select;

    const format = "HH:mm";
    const [isInterval, setIsInterval] = useState(false);
    const [arraySwitch, setArraySwitch] = useState({});
    const [autoShiftApplyForDepartment, setAutoShiftApplyForDepartment] =
        useState(false);
    const [autoCheckoutPosition, setAutoCheckoutPosition] = useState(false);
    const [jobPositions, setJobPosition] = useState();
    const [jobTitles, setJobTitle] = useState();


    useEffect(() => {
        setArraySwitch({
            ...props.dataShift
        })
    }, [props.dataShift])


    useEffect(() => {
        getJobPositions().then((r) => {
            setJobPosition(r)
        })

        getJobTitles(null, null, null, null, null, "actived").then((r) => {
            setJobTitle(r)
        })

    }, []);

    useEffect(() => {
        setIsInterval(arraySwitch.isInterval);
        setAutoShiftApplyForDepartment(arraySwitch.autoShiftApplyForDepartment);
        propsValueArraySwitch(arraySwitch);
    }, [arraySwitch]);

    useEffect(() => {
        if (props.success !== false) {
            setIsInterval(false);
            setAutoShiftApplyForDepartment(false);
            setAutoCheckoutPosition(false);
        }
    }, [props.success]);

    const initialShift = [
        {
            timeIn: "",
            timeOut: "",
            isOverDay: false,
        },
    ];

    const propsValueArraySwitch = (value) => {
        props.sendSwitch(value)
    }

    const onChangeisInterval = (value) => {

        const newIsInterval = !arraySwitch.isInterval;
        setArraySwitch({
            ...arraySwitch,
            isInterval: !arraySwitch.isInterval,
        });
        setIsInterval(value);

        if (!newIsInterval) {
            let {shiftIntervals} = props?.form?.getFieldsValue()

            if (shiftIntervals.length > 1) {
                shiftIntervals = [shiftIntervals[0]];
            }

            props?.form?.setFieldsValue({
                shiftIntervals
            })
        }
    };

    const onChangeAutoShiftApplyForDepartment = (value) => {
        setArraySwitch({
            ...arraySwitch,
            autoShiftApplyForDepartment: !arraySwitch.autoShiftApplyForDepartment,
        });
        setAutoShiftApplyForDepartment(value);
    };

    const onChangeAutoTimekeeping = (value) => {
        setArraySwitch({
            ...arraySwitch,
            autoTimekeeping: !arraySwitch.autoTimekeeping,
        });
    };

    const onChangeAutoCheckoutPosition = (value) => {
        setArraySwitch({
            ...arraySwitch,
            autoCheckoutPosition: !arraySwitch.autoCheckoutPosition,
        });
        setAutoCheckoutPosition(value);
    };

    const onChangeAutoShiftApplyForHoliday = (value) => {
        setArraySwitch({
            ...arraySwitch,
            autoShiftApplyForHoliday: !arraySwitch.autoShiftApplyForHoliday,
        });
    };

    const onChangeTimeOut = (value, index) => {
        handleAddWorkingTimes(index);
    };

    const onChangeByday = (value, index) => {

        handleAddWorkingTimes(index);
    };

    const handleAddWorkingTimes = (index) => {
        const shiftIntervals = props.form?.getFieldsValue()["shiftIntervals"];
        let totalHours = props.form?.getFieldsValue()["totalHours"] || 0;

        const hoursAndMini = shiftIntervals?.map((item) => {
            const timeIn = dayjs(item?.timeIn).format(format);
            let hours = parseInt(dayjs(item?.timeOut, format)?.subtract(timeIn)?.hour());
            const minutes = parseInt(dayjs(item?.timeOut, format)?.subtract(timeIn)?.minute());
            const isOverDay = item.isOverDay;
            return {
                hours,
                minutes,
                isOverDay,
            };
        });
        let Hours = 0;
        let Minutes = 0;

        for (let i = 0; i < hoursAndMini.length; i++) {
            Hours += hoursAndMini[i].hours;
            Minutes += hoursAndMini[i].minutes;
            if (Minutes === 60) {
                Hours += 1;
                Minutes = 0;
            }
            if (hoursAndMini[i].isOverDay === true) {
                Hours += 24
            }
        }

        if (Minutes === 0) {
            totalHours = Hours ? Hours : 0;
        } else {
            const minute = Minutes === 30 ? 5 : 0
            totalHours = Hours || Minutes ? Hours + "." + minute : 0;
        }
        props.form?.setFields([
            {
                name: ["totalHours"],
                value: totalHours,
            },
        ]);
    };

    const totalBreakTime = () => {
        const timeBreak = props.form?.getFieldsValue()["timeBreak"];
        const endBreak = props.form?.getFieldsValue()["endBreak"];
        const totalHours = props.form?.getFieldsValue()["totalHours"];
        const totalBreakTime = dayjs(endBreak, "H:mm").subtract(timeBreak?.format("H:mm"))?.format("H:mm");
        const total = totalHours - dayjs(totalBreakTime, "H:mm").hour()
        props.form?.setFields([
            {
                name: ["totalHours"],
                value: total,
            },
        ]);
    }

    const filterOption = (input, option) => {
        const normalizedInput = input.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        const normalizedOption = option?.dataSearch.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

        return normalizedOption.includes(normalizedInput);
    };


    function getPosition() {
        return jobPositions?.items?.map((item, key) => {
            return (
                <Option key={key} value={item.id} dataSearch={item.name}>
                    {item.name}
                </Option>
            )
        })
    }



    const style = {width: '100%'}

    const checkTimeOutTimeIn = async (_, value, index) => {

        const shiftIntervals = props.form?.getFieldsValue()["shiftIntervals"];

        if (!shiftIntervals[index]?.isOverDay && shiftIntervals[index].timeIn && shiftIntervals[index].timeOut) {

            return new Promise((resolve, reject) => {
                if (dayjs(shiftIntervals[index].timeOut).isBefore(dayjs(shiftIntervals[index].timeIn))) {
                    reject(t("tnp.components.timekeeping.text78"))
                }
                resolve()
            })
        }
        // reloadValidator(value, index);

    }

    const reloadValidator = (value, key) => {

        props?.form.validateFields([
            ["shiftIntervals", key, "timeOut"],
            ["shiftIntervals", key, "timeIn"],
        ])
    }
    const DEFAULT_CHECK_IN_FIRST = "03:00";
    return (
        <div id={props.id}>
            <Row gutter={12}>
                <Col xxl={{span: 6}} xl={{span: 6}} lg={{span: 6}}>
                    <Form.Item
                        labelCol={{
                            span: 24,
                        }}
                        wrapperCol={{
                            span: 24,
                        }}
                        label={t("shiftTitle.codeShift")}
                        name="code"
                        labelAlign="right"
                        rules={[
                            {
                                required: true,
                                message: t("tnp.components.timekeeping.text1"),
                                type: "string",
                                whitespace: true,
                            },
                            {
                                max: 100,
                                message: t("tnp.components.timekeeping.text71")
                            }
                        ]}
                    >
                        <Input name="code"
                               disabled={!!id}
                               placeholder={t("tnp.components.timekeeping.text63")}/>
                    </Form.Item>
                </Col>
                <Col xxl={{span: 6}} xl={{span: 6}} lg={{span: 6}}>
                    <Form.Item
                        labelCol={{
                            span: 24,
                        }}
                        wrapperCol={{
                            span: 24,
                        }}
                        label={t("shiftTitle.nameSHift")}
                        name="name"
                        labelAlign="right"
                        rules={[
                            {
                                required: true,
                                message: t("tnp.components.timekeeping.text2"),
                                type: "string",
                                whitespace: true,
                            },
                            {
                                max: 100,
                                message: t("tnp.components.timekeeping.text72")
                            }
                        ]}
                    >
                        <Input disabled={!!id} placeholder={t("tnp.components.timekeeping.text64")}/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={12}>
                <Col xxl={{span: 8}} xl={{span: 8}} lg={{span: 8}}>
                    <Form.Item
                        name="isInterval"
                        valuePropName="checked"
                    >
                        <Switch
                            name="isInterval"
                            size="small"
                            onChange={onChangeisInterval}
                            checked={arraySwitch?.isInterval}
                            className={'mr-1 mb-1'}
                        />
                        <span>{t("shiftTitle.manyShift")}</span>
                    </Form.Item>
                </Col>
            </Row>
            <Form.List name="shiftIntervals" initialValue={initialShift}>
                {(fields, {add, remove}) => (
                    <>
                        {fields.map(({key, name, fieldKey, ...restField}, index) => (
                            <Row gutter={12}>
                                <Col xxl={{span: 6}} xl={{span: 6}} lg={{span: 6}}>
                                    <Form.Item
                                        labelCol={{
                                            span: 24,
                                        }}
                                        wrapperCol={{
                                            span: 24,
                                        }}
                                        {...restField}
                                        label={t("shiftTitle.timeIn")}
                                        validateTrigger={["onChange", "onBlur"]}
                                        name={[name, "timeIn"]}
                                        rules={[
                                            {
                                                required: true,
                                                message: t("tnp.components.timekeeping.text3"),
                                            },
                                            {
                                                validator: (rule, value) => checkTimeOutTimeIn(rule, value, index),
                                            },
                                        ]}
                                    >
                                        <TimePicker style={style} format={format} changeOnBlur={true}
                                                    // onChange={(value) => reloadValidator(value, name)}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col xxl={{span: 6}} xl={{span: 6}} lg={{span: 6}}>
                                    <Form.Item
                                        labelCol={{
                                            span: 24,
                                        }}
                                        wrapperCol={{
                                            span: 24,
                                        }}
                                        {...restField}
                                        label={t("shiftTitle.timeOut")}
                                        validateTrigger={["onChange", "onBlur"]}
                                        name={[name, "timeOut"]}
                                        rules={[
                                            {
                                                required: true,
                                                message: t("tnp.components.timekeeping.text4"),
                                            },
                                            {
                                                validator: (rule, value) => checkTimeOutTimeIn(rule, value, index),
                                            },
                                        ]}
                                    >
                                        {/*<DG_TimeSelect onChange={(value) => onChangeTimeOut(value, index)}/>*/}
                                        <TimePicker style={style}
                                                    format={format} changeOnBlur={true}
                                                    onChange={(value) => {
                                                        onChangeTimeOut(value, index)
                                                        reloadValidator(value, name)
                                                    }}
                                        />

                                    </Form.Item>
                                </Col>

                                <Col xxl={{span: 6}} xl={{span: 6}} lg={{span: 6}}>
                                    <Form.Item
                                        label={t("shiftTitle.byDay")}
                                        name={[name, "isOverDay"]}
                                        labelCol={{
                                            span: 24,
                                        }}
                                        wrapperCol={{
                                            span: 24,
                                        }}
                                        rules={[
                                            {
                                                required: true,
                                                message: t("tnp.components.timekeeping.text5"),
                                            }
                                        ]}
                                        initialValue={false}
                                    >
                                        <Select
                                            {...restField}
                                            onChange={(value) => {
                                                onChangeByday(value, index)
                                                checkTimeOutTimeIn(null, null, index)
                                                reloadValidator(value, name)
                                            }}
                                        >
                                            <Option value={true}>{t("shiftTitle.yes")}</Option>
                                            <Option value={false}>{t("shiftTitle.no")}</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                                {index > 0 ? (
                                    <Col span={1}>
                                        <div className={'mt-9'}>
                                            <MinusCircleOutlined
                                                onClick={() => {
                                                    remove(name);
                                                    handleAddWorkingTimes(index);
                                                }}
                                            />
                                        </div>
                                    </Col>
                                ) : null}
                                <Divider/>
                            </Row>
                        ))}
                        {isInterval ? (
                            <Col xxl={{span: 1}} xl={{span: 1}} lg={{span: 1}}>
                                <Form.Item>
                                    <Button
                                        block
                                        type="dashed"
                                        onClick={() => add()}
                                        icon={<PlusOutlined/>}
                                    ></Button>
                                </Form.Item>
                            </Col>
                        ) : (
                            <></>
                            // fields.length > 1 && (
                            //     <Col xxl={{ span: 1 }} xl={{ span: 1 }} lg={{ span: 1 }}>
                            //         <Form.Item>
                            //             <Button
                            //                 block
                            //                 type="dashed"
                            //                 onClick={() => {
                            //                     remove(fields[1].name); // Chỉ giữ lại item đầu tiên
                            //                     onChangeisInterval(false); // Đặt giá trị của Switch về false
                            //                 }}
                            //             >
                            //                 <MinusOutlined />
                            //             </Button>
                            //         </Form.Item>
                            //     </Col>
                            // )
                        )}
                    </>
                )}
            </Form.List>
            {!isInterval ?
                <Row gutter={12}>
                    <Col xxl={{span: 6}} xl={{span: 6}} lg={{span: 6}}>
                        <Form.Item
                            labelCol={{
                                span: 24,
                            }}
                            wrapperCol={{
                                span: 24,
                            }}
                            label={t("shiftTitle.timeBreak")}
                            name="timeBreak"
                        >
                            <TimePicker style={style} format={format} changeOnBlur={true}/>
                        </Form.Item>
                    </Col>
                    <Col xxl={{span: 6}} xl={{span: 6}} lg={{span: 6}}>
                        <Form.Item
                            labelCol={{
                                span: 24,
                            }}
                            wrapperCol={{
                                span: 24,
                            }}
                            label={t("shiftTitle.endBreak")}
                            name="endBreak"

                        >
                            <TimePicker style={style} onChange={totalBreakTime} format={format} changeOnBlur={true}/>

                        </Form.Item>
                    </Col>
                </Row>
                : <></>}

            <ShiftGps
                form={props.form}
            />

            <Row gutter={12}>
                <Col xxl={{span: 6}} xl={{span: 6}} lg={{span: 6}}>
                    <Form.Item
                        label={t("shiftTitle.flexibleHours")}
                        name="flexibleHours"
                        labelCol={{
                            span: 24,
                        }}
                        wrapperCol={{
                            span: 24,
                        }}
                        tooltip={() => {
                            return t("tnp.components.timekeeping.text6")
                        }}
                    >
                        <TimePicker style={style} name="flexibleHours" format={format} changeOnBlur={true}/>
                    </Form.Item>
                </Col>
                <Col xxl={{span: 6}} xl={{span: 6}} lg={{span: 6}}>
                    <Form.Item
                        label={t("tnp.components.timekeeping.text7")}
                        name="flexibleApplyFor"
                        labelCol={{
                            span: 24,
                        }}
                        wrapperCol={{
                            span: 24,
                        }}
                        initialValue={"before"}>
                        <Select
                            name="flexibleApplyFor">
                            <Option value={"after"}>{t("tnp.components.timekeeping.afterCheckIn")}</Option>
                            <Option value={"before"}>{t("tnp.components.timekeeping.text8")}</Option>
                            <Option value={"both"}>{t("tnp.components.timekeeping.text9")}</Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col xxl={{span: 6}} xl={{span: 6}} lg={{span: 6}}>
                    <Form.Item
                        initialValue="1"
                        label={t("shiftTitle.totalWork")}
                        name="totalWork"
                        labelCol={{
                            span: 24,
                        }}
                        wrapperCol={{
                            span: 24,
                        }}
                    >
                        {/*<InputNumber*/}
                        {/*    name="totalWork"*/}
                        {/*    controls={false}*/}
                        {/*    className={'w-full'}*/}
                        {/*    min={0}*/}
                        {/*    max={9999}*/}
                        {/*    parser={(value) =>*/}
                        {/*        value.replace(/\$\s?|(,*)/g, "")*/}
                        {/*    }*/}
                        {/*/>*/}

                        <InputDecimal
                            form = {props?.form}
                            name="totalWork"
                        />

                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={12}>
                <Col xxl={{span: 6}} xl={{span: 6}} lg={{span: 6}}>
                    <Form.Item
                        initialValue={dayjs(DEFAULT_CHECK_IN_FIRST,format)}
                        labelCol={{
                            span: 24,
                        }}
                        wrapperCol={{
                            span: 24,
                        }}
                        label={t("shiftTitle.checkInFirst")}
                        name="checkInFirst"
                        tooltip={() => {
                            return t("tnp.components.timekeeping.text10")
                        }}
                    >
                        <TimePicker style={style}
                                    name="checkInFirst"
                                    format={format} changeOnBlur={true}
                                    defaultValue={dayjs(DEFAULT_CHECK_IN_FIRST,format) }
                        />
                    </Form.Item>
                </Col>
                <Col xxl={{span: 6}} xl={{span: 6}} lg={{span: 6}}>
                    <Form.Item
                        initialValue={dayjs(DEFAULT_CHECK_IN_FIRST,format)}
                        labelCol={{
                            span: 24,
                        }}
                        wrapperCol={{
                            span: 24,
                        }}
                        label={t("shiftTitle.checkInLater")}
                        name="checkInLater"
                    >
                        <TimePicker style={style}
                                    name="checkInLater"
                                    format={format} changeOnBlur={true}
                                    defaultValue={dayjs(DEFAULT_CHECK_IN_FIRST,format) }
                        />
                    </Form.Item>
                </Col>
            </Row>
            {/*<Row gutter={12}>*/}
            {/*    <Col xxl={{span: 10}} xl={{span: 10}} lg={{span: 10}}>*/}
            {/*        <Form.Item*/}
            {/*            name="autoShiftApplyForDepartment"*/}
            {/*        >*/}
            {/*            <Switch*/}
            {/*                size="small"*/}
            {/*                name="autoShiftApplyForDepartment"*/}
            {/*                onChange={onChangeAutoShiftApplyForDepartment}*/}
            {/*                checked={arraySwitch.autoShiftApplyForDepartment}*/}
            {/*                className={'mr-1 mb-1'}*/}
            {/*            />*/}
            {/*            <span>*/}
            {/*              {t("shiftTitle.checkByDepartmentLocation")}*/}
            {/*            </span>*/}
            {/*        </Form.Item>*/}
            {/*    </Col>*/}
            {/*</Row>*/}
            {/*{autoShiftApplyForDepartment ?*/}
            {/*    <Form.List name="shiftApplyFors" initialValue={fors}>*/}
            {/*        {(fields, {add, remove}) => (*/}
            {/*            <>*/}
            {/*                {fields.map(({key, name, fieldKey, ...restField}, index) => (*/}
            {/*                    <Row gutter={12}>*/}
            {/*                        <Col xxl={{span: 6}} xl={{span: 6}} lg={{span: 6}}>*/}
            {/*                            <Form.Item*/}
            {/*                                {...restField}*/}
            {/*                                name={[name, 'departmentId']}*/}
            {/*                                label={t("shiftTitle.department")}*/}
            {/*                                labelCol={{*/}
            {/*                                    span: 24,*/}
            {/*                                }}*/}
            {/*                                wrapperCol={{*/}
            {/*                                    span: 24,*/}
            {/*                                }}*/}
            {/*                            >*/}
            {/*                                <DG_TreeSelect_Department*/}
            {/*                                    showCheckedStrategy={TreeSelect.SHOW_ALL}*/}
            {/*                                    ultiple*/}
            {/*                                    placeholder={t("tnp.components.timekeeping.text11")}*/}
            {/*                                />*/}
            {/*                            </Form.Item>*/}
            {/*                        </Col>*/}

            {/*                        <Col xxl={{span: 6}} xl={{span: 6}} lg={{span: 6}}>*/}
            {/*                            <Form.Item*/}
            {/*                                label={t("shiftTitle.position")}*/}
            {/*                                name={[name, 'jobPositionId']}*/}
            {/*                                labelCol={{*/}
            {/*                                    span: 24,*/}
            {/*                                }}*/}
            {/*                                wrapperCol={{*/}
            {/*                                    span: 24,*/}
            {/*                                }}*/}
            {/*                            >*/}
            {/*                                <Select*/}
            {/*                                    name="jobPositionId"*/}
            {/*                                    {...restField}*/}
            {/*                                    showSearch*/}
            {/*                                    optionFilterProp="children"*/}
            {/*                                    filterOption={filterOption}*/}
            {/*                                    allowClear*/}
            {/*                                    maxTagCount={2}*/}
            {/*                                    placeholder={t("tnp.components.timekeeping.text12")}>*/}
            {/*                                    {getPosition()}*/}
            {/*                                </Select>*/}
            {/*                            </Form.Item>*/}
            {/*                        </Col>*/}

            {/*                        <Col xxl={{span: 6}} xl={{span: 6}} lg={{span: 6}}>*/}
            {/*                            <Form.Item*/}
            {/*                                label={t("shiftTitle.chucvu")}*/}
            {/*                                name={[name, 'jobTitleId']}*/}
            {/*                                labelCol={{*/}
            {/*                                    span: 24,*/}
            {/*                                }}*/}
            {/*                                wrapperCol={{*/}
            {/*                                    span: 24,*/}
            {/*                                }}*/}
            {/*                            >*/}
            {/*                                <Select*/}
            {/*                                    name="jobTitleId"*/}
            {/*                                    {...restField}*/}
            {/*                                    maxTagCount={2}*/}
            {/*                                    placeholder={t("tnp.components.timekeeping.text13")}*/}
            {/*                                    showSearch*/}
            {/*                                    optionFilterProp="children"*/}
            {/*                                    filterOption={filterOption}*/}
            {/*                                    allowClear*/}
            {/*                                >*/}
            {/*                                    {getChucVu()}*/}
            {/*                                </Select>*/}
            {/*                            </Form.Item>*/}
            {/*                        </Col>*/}
            {/*                        {index > 0 ? (*/}
            {/*                            <Col xl={{span: 1}}*/}
            {/*                                 lg={{span: 1}}>*/}
            {/*                                <div className={'mt-9'}>*/}
            {/*                                    <MinusCircleOutlined*/}
            {/*                                        onClick={() => {*/}
            {/*                                            remove(name);*/}
            {/*                                        }}*/}
            {/*                                    />*/}
            {/*                                </div>*/}
            {/*                            </Col>*/}
            {/*                        ) : null}*/}
            {/*                        <Divider/>*/}

            {/*                    </Row>*/}
            {/*                ))}*/}
            {/*                <Col xxl={{span: 1}} xl={{span: 1}} lg={{span: 1}}>*/}
            {/*                    <Form.Item>*/}
            {/*                        <Button*/}
            {/*                            block*/}
            {/*                            type="dashed"*/}
            {/*                            onClick={() => add()}*/}
            {/*                            icon={<PlusOutlined/>}*/}
            {/*                        ></Button>*/}
            {/*                    </Form.Item>*/}
            {/*                </Col>*/}

            {/*            </>*/}
            {/*        )}*/}
            {/*    </Form.List>*/}
            {/*    : <></>}*/}
            {/*<Row gutter={12}>*/}
            {/*    <Col xxl={{span: 10}} xl={{span: 10}} lg={{span: 10}}>*/}
            {/*        <Form.Item*/}
            {/*            name="autoShiftApplyForHoliday"*/}
            {/*        >*/}
            {/*            <Switch*/}
            {/*                size="small"*/}
            {/*                onChange={onChangeAutoShiftApplyForHoliday}*/}
            {/*                checked={arraySwitch.autoShiftApplyForHoliday}*/}
            {/*                className={'mr-1 mb-1'}*/}
            {/*            />*/}
            {/*            <span>*/}
            {/*              {t("shiftTitle.shiftHoliday")}*/}
            {/*            </span>*/}
            {/*        </Form.Item>*/}
            {/*    </Col>*/}
            {/*</Row>*/}
            <Row gutter={12}>
                <Col xxl={{span: 10}} xl={{span: 10}} lg={{span: 10}}>
                    <Form.Item
                        name="autoTimekeeping"

                        tooltip={() => {
                            return t("tnp.components.timekeeping.text14")
                        }}
                    >
                        <Switch
                            size="small"
                            name="autoTimekeeping"
                            onChange={onChangeAutoTimekeeping}
                            checked={arraySwitch.autoTimekeeping}
                            className={'mr-1 mb-1'}
                        />
                        <span>
                          {t("shiftTitle.timekeepingAuto")}&nbsp;&nbsp;
                            <Tooltip title=
                                         {t("shiftTitle.timekeepingAutoToolTip")}>
                                    <QuestionCircleOutlined/>
                                </Tooltip>
                        </span>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={12}>
                <Col xxl={{span: 10}} xl={{span: 10}} lg={{span: 10}}>

                    <Form.Item
                        name="autoCheckoutPosition"
                        labelCol={{
                            span: 24,
                        }}
                        wrapperCol={{
                            span: 24,
                        }}
                    >
                        <Switch
                            size="small"
                            onChange={onChangeAutoCheckoutPosition}
                            checked={arraySwitch.autoCheckoutPosition || autoCheckoutPosition}
                            className={'mr-1 mb-1'}
                        />
                            <span>
                              {t("shiftTitle.checkApplyToLocation")}&nbsp;&nbsp;
                                <Tooltip title=
                                             {t("shiftTitle.checkApplyToLocationToolTip")}>
                                    <QuestionCircleOutlined/>
                                </Tooltip>
                            </span>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={12}>
                <Col xxl={{span: 9}} xl={{span: 9}} lg={{span: 9}}>
                    <Form.Item
                        name={['shiftAutoCheckoutPositionIds']}
                        rules={[{
                            required: autoCheckoutPosition,
                            message: t("tnp.components.timekeeping.text15")
                        },]}
                    >
                        <Select
                            name="shiftAutoCheckoutPositionIds"
                            mode="multiple"
                            style={{width: "100%"}}
                            disabled={!arraySwitch.autoCheckoutPosition}
                            placeholder={t("tnp.components.timekeeping.text12")}
                            showSearch
                            optionFilterProp="children"
                            filterOption={filterOption}
                            allowClear
                        >
                            {getPosition()}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
            {/*<Row gutter={12}>*/}
            {/*    <Col xxl={{span: 6}} xl={{span: 6}} lg={{span: 6}}>*/}
            {/*        <Form.Item*/}
            {/*            label={t("shiftTitle.department")}*/}
            {/*            name={['shiftApplyForDepartmentIds']}*/}
            {/*        >*/}
            {/*            <DG_TreeSelect_Department*/}
            {/*                {...tProps}*/}
            {/*                treeCheckable={"true"}*/}
            {/*                showCheckedStrategy={TreeSelect.SHOW_ALL}*/}
            {/*                ultiple*/}
            {/*                placeholder={t("placeholderWorkplace.CurrentDepartment")}*/}
            {/*            />*/}

            {/*        </Form.Item>*/}
            {/*    </Col>*/}
            {/*</Row>*/}
            {/*<Row gutter={12}>*/}
            {/*    <Col xxl={{span: 6}} xl={{span: 6}} lg={{span: 6}}>*/}
            {/*        <Form.Item*/}
            {/*            label={t("shiftTitle.position")}*/}
            {/*            name={['shiftApplyForPositionIds']}*/}
            {/*        >*/}
            {/*            <Select*/}
            {/*                name="shiftApplyForPositionIds"*/}
            {/*                showSearch*/}
            {/*                optionFilterProp="children"*/}
            {/*                filterOption={filterOption}*/}
            {/*                allowClear*/}
            {/*                mode="multiple"*/}
            {/*                placeholder={t("tnp.components.timekeeping.text12")}*/}
            {/*                maxTagCount={2}>*/}
            {/*                {getPosition()}*/}
            {/*            </Select>*/}
            {/*        </Form.Item>*/}
            {/*    </Col>*/}
            {/*</Row>*/}
        </div>
    );
};

export default GeneralSeting;
